import { GatewayTokenDto } from '../../credit-card/gateway-token.dto';
import { ArbContactInfoDto } from './arb-contact-info.dto';
import { BankAccountTypesEnum } from './bank-account-types.enum';

export interface ArbCreateDto {
  BillingId: number;
  CardNum: string;
  Last4Digits: string;
  CCType: string;
  PaymentTypeID: number;
  ProfileID: number;
  Inactive: boolean;
  AmountPerCycle: number;
  ExpireMonth: number;
  ExpireYear: number;
  Pin: string;
  Descr: string;
  ContactInfo: ArbContactInfoDto;
  SecurityCode: string;
  NameOnAccount: string;
  BankName: string;
  RoutingNumber: string;
  AccountNumber: string;
  AccountType: BankAccountTypesEnum;
  GatewayTokens?: GatewayTokenDto[];
}

export function initializedArbCreateDto() {
  return {
    ContactInfo: {} as ArbContactInfoDto,
  } as ArbCreateDto;
}
